import React, { useState } from 'react'
import AutoSuggestions from '../../Services/Queries/AutoSuggestions'
import AwsConfig from '../../Config/AwsConfig'
import { FaCopy } from 'react-icons/fa'
import GetFormattedDate from './getFormateddateforlistmovies'
import Config from '../../Config/Config.json'
import { ToastContainer, toast } from 'react-toastify' // Importing toast container and toast from react-toastify
import 'react-toastify/dist/ReactToastify.css'
const MovieAndPersonURLs = () => {
  const [searchValue, setSearchValue] = useState('')
  const [searchResults, setSearchResults] = useState({
    persons: [],
    movies: [],
  })

  const handleSearchChange = async event => {
    const { value } = event.target
    setSearchValue(value)
    try {
      if (value.length >= 3) {
        const input = { search: value, type: 'all', limit: 100, from: 0, status: 'published' }
        const { movieHits, personHits } = await AutoSuggestions(input)
        setSearchResults({
          persons: personHits || [],
          movies: movieHits || [],
        })
      } else {
        setSearchResults({ persons: [], movies: [] })
      }
    } catch (error) {
      console.error('Error fetching data:', error)
      setSearchResults({ persons: [], movies: [] })
    }
  }

  const copyToClipboard = async (PK, language, type) => {
    let baseUrl = ''

    if (Config.Environment === 'Production') {
      // Production environment URL
      baseUrl = 'https://telugu.yousay.tv'
    } else if (Config.Environment === 'Development') {
      // Staging environment URL
      baseUrl = 'https://stagingyousay.ktree.org'
    } else {
      // Default URL for other environments
      baseUrl = 'https://stagingyousay.ktree.org'
    }

    let url = ''
    if (language === 'Te') {
      url = `${baseUrl}/tfidb/${type === 'movies' ? 'movie' : type === 'webseries' ? 'webSeries' : 'person'}/${PK}`
    } else {
      url = `${baseUrl}/en/tfidb/${type === 'movies' ? 'movie' : type === 'webseries' ? 'webSeries' : 'person'}/${PK}`
    }

    try {
      await navigator.clipboard.writeText(url)
      toast.success(`URL_${language} copied to clipboard ${url}`)
    } catch (error) {
      console.error('Error copying URL to clipboard:', error)
    }
  }

  const renderHits = (searchResults, type) => (
    <div
      className='searchfield'
      style={{
        height: searchResults.length >= 1 ? '60vh' : '',
        width: '100%',
        position: 'relative',
        zIndex: '1',
      }}
    >
      <label>{type === 'Movie' ? 'movies/webseries' : 'persons'}</label>
      <div>
        {searchResults.map((result, index) => {
          let posterUrl = result.posterURL
          const releaseDate = GetFormattedDate(parseInt(result.movieReleasedDate || '0', 10))
          if (result.posterURL === 'none' || result.posterURL === '') {
            posterUrl = AwsConfig.movieCdnUrl + AwsConfig.avatharPath + AwsConfig.personStaticImage
          } else if (result.posterURL && !result.posterURL.includes(AwsConfig.movieCdnUrl)) {
            posterUrl = AwsConfig.movieCdnUrl + result.posterURL
          }

          const displayText = type === 'Movie' ? result.title_En : result.name_En
          const additionalInfo = type === 'Movie' ? result.wikipediaLink : result.personWikiURL

          return (
            <div
              key={index}
              style={{
                width: '100%',
                marginRight: 'auto',
                boxSizing: 'unset',
                height: '4rem',
              }}
            >
              <ul className='list-group list-group-flush'>
                <li className='list-group-item' style={{ marginRight: 'auto', width: '100%' }}>
                  <div className='media d-flex justify-content-center align-items-center'>
                    {posterUrl && (
                      <img
                        style={{
                          width: '2.5rem',
                          height: '2.5rem',
                          marginRight: 'auto',
                        }}
                        className='mr-3 align-self-center'
                        src={posterUrl}
                        alt='Poster'
                      />
                    )}
                    <div
                      className='media-body align-self-center'
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        // flexWrap: 'wrap',
                        fontSize: '10px',
                      }}
                    >
                      <span>
                        <b>{`${type} Name:`}</b> {displayText}
                      </span>
                      {releaseDate && (
                        <span>
                          <b>Release Date:</b>
                          {releaseDate.toString()}
                        </span>
                      )}
                      {result.roles && (
                        <span
                          style={{ whiteSpace: 'pre-wrap', width: '30%' }}
                        >{`(${result.roles.toString()})`}</span>
                      )}
                      <span>{additionalInfo}</span>
                    </div>
                    <div style={{ display: 'flex', gap: '15px' }}>
                      {['Te', 'En'].map((language, index) => (
                        <span
                          key={index}
                          type='button'
                          onClick={() => copyToClipboard(result.PK, language, result.contentType)}
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            // gap: 'px',
                            height: '3rem',
                          }}
                        >
                          <FaCopy />
                          <span style={{ fontSize: '12px' }}>{language}</span>
                        </span>
                      ))}
                    </div>
                  </div>
                  {/* <hr style={{ background: 'black', color: 'black' }} /> */}
                </li>
              </ul>
            </div>
          )
        })}
      </div>
    </div>
  )

  return (
    <div>
      <ToastContainer
        position='top-right'
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <label>getMovieAndPersonUrls:</label>
      <input value={searchValue} className='form-control' onChange={handleSearchChange} />
      <div style={{ display: 'flex', gap: '10px', marginTop: '20px' }}>
        {searchResults.movies &&
          searchResults.movies.length >= 1 &&
          renderHits(searchResults.movies, 'Movie')}
        {searchResults.persons &&
          searchResults.persons.length >= 1 &&
          renderHits(searchResults.persons, 'Person')}
      </div>
    </div>
  )
}

export default MovieAndPersonURLs
